import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>Spatial temporal LU analysis reveals increase in built-up area at the cost of forest cover, signifies anthropogenic pressure. The temporal analysis of forest and non-forest cover with temperature indicates a strong relationship among LU and bio-physical variables. The results revealed forest cover has reduced from 15.84% (1985) to 9.65% (2018) whereas non-forest cover has increased from 81.70% (1985) to 87.41% (2018). However, the temporal analysis of land surface temperature shows increase in temperature over the periods. Therefore, it can be understood that large scale deforestation will lead to increase in temperature. The investigation across agro-climatic zones of Karnataka, depicts increase in temperature in hot dry semi-arid regions which are devoid of forest cover. However, there is not much increase in hot humid region as the region has healthy vegetation. However, escalations in anthropogenic activities leading to degradation of forests. Will enhance the regional temperature. Statistical analysis of LST and LU indicates a negative correlation between vegetation with an increase in LST. The general trend in the ambient temperature of Karnataka further clarifies that there was a fundamental drift of temperature rise in recent years, especially during the last decade. Therefore, there is an urgent need to mitigate these issues and possible drought conditions. Proper land use planning and restoration of degraded land through the afforestation with native species would help in mitigating the increase in temperature.</p>
<h5>Acknowledgement</h5>
<p>We are grateful to (i) the ENVIS division, The Ministry of Environment, Forests and Climate Change, Government of India and (ii) Indian Institute of Science for the financial and infrastructure support.</p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
